/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Asterisk({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.6 2a.6.6 0 0 0-1.2 0V6.55L4.182 3.333a.6.6 0 1 0-.849.849L6.551 7.4H2a.6.6 0 0 0 0 1.2H6.55l-3.218 3.218a.6.6 0 1 0 .848.849L7.4 9.448V14a.6.6 0 1 0 1.2 0V9.448l3.218 3.219a.6.6 0 0 0 .849-.849L9.448 8.6H14a.6.6 0 1 0 0-1.2H9.448l3.219-3.219a.6.6 0 0 0-.849-.848L8.6 6.551z" /></svg>;
}
;